import DOMPurify from 'dompurify';

interface SanitizeOptions {
	ALLOWED_TAGS?: string[];
	breakLines?: boolean;
}

const useSanitizedHTML = (
	dirtyHTML: string,
	options: SanitizeOptions = { ALLOWED_TAGS: ['b', 'i', 'br'], breakLines: true }
) => {
	const { ALLOWED_TAGS = ['b', 'i', 'br'], breakLines = true } = options;

	// Replace \n with <br /> before sanitizing, if breakLines is true
	const htmlWithBreaks = breakLines
		? dirtyHTML.replace(/\n/g, '<br />')
		: dirtyHTML;

	// Sanitize the HTML
	const sanitizedHTML = {
		__html: DOMPurify.sanitize(htmlWithBreaks, { ALLOWED_TAGS }),
	};

	return sanitizedHTML;
};

export default useSanitizedHTML;
